import { requestData } from "@/api/request";
import { DeleteRequest, PageResult } from "@/types/common";
import {
  CaptchaVO,
  EmailCodeLoginRequest,
  EmailVerificationCodeRequest,
  LoginUserVO,
  PhoneCodeSendRequest,
  PhoneLoginRequest,
  UserAddRequest,
  UserCommunityStatsVO,
  UserLoginRequest,
  UserQueryRequest,
  UserRegisterRequest,
  UserReviewTodoVO,
  UserUpdateRequest,
  UserUpdateMyRequest,
  UserVO,
} from "@/types/user";

export function userLogin(data: UserLoginRequest) {
  return requestData<LoginUserVO>({
    url: "/user/login",
    method: "POST",
    data,
  });
}

export function sendPhoneLoginCode(data: PhoneCodeSendRequest) {
  return requestData<boolean>({
    url: "/user/phone/code",
    method: "POST",
    data,
  });
}

export function getCaptcha() {
  return requestData<CaptchaVO>({
    url: "/user/captcha",
    method: "GET",
  });
}

export function sendEmailCode(data: EmailVerificationCodeRequest) {
  return requestData<boolean>({
    url: "/user/email/code",
    method: "POST",
    data,
  });
}

export function emailAuthenticate(data: EmailCodeLoginRequest) {
  return requestData<LoginUserVO>({
    url: "/user/email/auth",
    method: "POST",
    data,
  });
}

export function userLoginByPhone(data: PhoneLoginRequest) {
  return requestData<LoginUserVO>({
    url: "/user/login/phone",
    method: "POST",
    data,
  });
}

export function getWxOpenLoginUrl() {
  return requestData<string>({
    url: "/user/login/wx_open/url",
    method: "GET",
  });
}

export function userRegister(data: UserRegisterRequest) {
  return requestData<number>({
    url: "/user/register",
    method: "POST",
    data,
  });
}

export function userLogout() {
  return requestData<boolean>({
    url: "/user/logout",
    method: "POST",
  });
}

export function getLoginUser() {
  return requestData<LoginUserVO>({
    url: "/user/get/login",
    method: "GET",
  });
}

export function updateMyUser(data: UserUpdateMyRequest) {
  return requestData<boolean>({
    url: "/user/update/my",
    method: "POST",
    data,
  });
}

export function getMyReviewTodoCount() {
  return requestData<UserReviewTodoVO>({
    url: "/user/review/todo-count",
    method: "GET",
  });
}

export function getUserCommunityStats(userId: string | number) {
  return requestData<UserCommunityStatsVO>({
    url: "/user/community/stats",
    method: "GET",
    params: { userId },
  });
}

export function listUsers(data: UserQueryRequest) {
  return requestData<PageResult<UserVO>>({
    url: "/user/list/page/vo",
    method: "POST",
    data,
  });
}

export function addUser(data: UserAddRequest) {
  return requestData<number>({
    url: "/user/add",
    method: "POST",
    data,
  });
}

export function updateUser(data: UserUpdateRequest) {
  return requestData<boolean>({
    url: "/user/update",
    method: "POST",
    data,
  });
}

export function deleteUser(data: DeleteRequest) {
  return requestData<boolean>({
    url: "/user/delete",
    method: "POST",
    data,
  });
}
